export const hidden = { opacity: 0, y: 30 };
export const hiddenHero = { opacity: 0, y: 40 };
export const hiddenSmall = { opacity: 0, y: 15 };
export const hiddenMd = { opacity: 0, y: 20 };
export const hiddenScale = { opacity: 0, scale: 0.9 };
export const visible = { opacity: 1, y: 0 };
export const visibleScale = { opacity: 1, scale: 1 };
export const viewOnce = { once: true };

// Complete, stable framer-motion prop bundles. Spread these instead of writing
// inline objects, which allocate a new reference on every parent render.
export const FADE_UP_SM = { initial: { opacity: 0, y: 12 }, animate: visible, transition: { duration: 0.4 } };
export const FADE_UP = { initial: { opacity: 0, y: 16 }, animate: visible, transition: { duration: 0.5 } };
export const FADE_UP_LG = { initial: hiddenMd, animate: visible, transition: { duration: 0.5 } };

export const fadeUpDelayed = (delay) => ({
  initial: { opacity: 0, y: 16 },
  animate: visible,
  transition: { duration: 0.5, delay },
});

export const fadeUpLgDelayed = (delay) => ({
  initial: hiddenMd,
  animate: visible,
  transition: { duration: 0.5, delay },
});

export const fadeUpStaggered = (index, base = 0.1, step = 0.1) => ({
  initial: hiddenMd,
  animate: visible,
  transition: { duration: 0.4, delay: base + index * step },
});

// Scroll reveal: fires once when the block enters the viewport.
export const REVEAL = {
  initial: { opacity: 0, y: 18 },
  whileInView: visible,
  viewport: { once: true, amount: 0.2 },
  transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
};

export const revealDelayed = (delay) => ({
  ...REVEAL,
  transition: { ...REVEAL.transition, delay },
});
